// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { fromJS, Map } from 'immutable';
import { createSelector } from 'reselect';
import { NAME } from './constants.js';
import type { LocalesSlice } from './types.js';

export const getLocalesState = (state: LocalesSlice) => state[NAME];

const getPropsLocale = (_state: unknown, props: { locale?: string }): string | undefined => props.locale;

export const getVersion = createSelector(getLocalesState, (locales) => locales.getIn(['data', 'version']));

export const getLocales = createSelector(getLocalesState, (locales) => {
  const schema = locales.get('data');
  const defaultLocale = schema.get('defaultLocale');
  return schema.get('locales').map((code) =>
    Map({
      code,
      default: code === defaultLocale
    })
  );
});

export const getLocalesTableData = createSelector(getLocales, (locales) => locales.toJS());

export const getDefaultLocale = createSelector(getLocalesState, (state) => state.getIn(['data', 'defaultLocale'], ''));

export const getLocale = createSelector(
  getDefaultLocale,
  getPropsLocale,
  (defaultLocale, propsLocale) => propsLocale ?? defaultLocale
);

export const getDefaultLocaleInitialData = createSelector(getDefaultLocale, (defaultLocale) => {
  const [language, country] = defaultLocale.split('-');
  return fromJS({
    language,
    country,
    default: true
  });
});
